var __jsx = React.createElement;
import React from "react";
import { Icon } from "@syarahtech/ui";
var AdditionalRequirementsSection = function AdditionalRequirementsSection(_ref) {
  var title = _ref.title,
    items = _ref.items;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 md:w-1/2"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-primary-old text-sm font-bold text-start md:text-base"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg py-4 px-3 shadow-[0_0_6px_0_rgba(74,74,74,0.08)] min-h-[156px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(AdditionalRequirementItem, {
      key: item.key,
      item: item
    });
  }))));
};
var AdditionalRequirementItem = function AdditionalRequirementItem(_ref2) {
  var item = _ref2.item;
  if (!(item !== null && item !== void 0 && item.title) || item.title.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1.5"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--check-circle-rounded",
    className: "text-success shrink-0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-xs font-medium leading-5"
  }, item.title));
};
export default AdditionalRequirementsSection;